import { Check } from "lucide-react";
import { STATUSES, fmtDate } from "@/lib/api";

export const StatusTimeline = ({ status, history }) => {
  const current = STATUSES.findIndex((s) => s.key === status);
  return (
    <ol className="relative space-y-0" data-testid="status-timeline">
      {STATUSES.map((s, i) => {
        const done = i <= current;
        const ev = [...history].reverse().find((h) => h.status === s.key);
        return (
          <li key={s.key} className="flex gap-5 pb-8 last:pb-0 relative" data-testid={`timeline-step-${s.key}`}>
            {i < STATUSES.length - 1 && (
              <span className={`absolute left-[15px] top-8 bottom-0 w-px ${i < current ? "bg-[#7B5338]" : "bg-[#DDD3C6]"}`} />
            )}
            <span className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 border transition-colors duration-300 ${done ? "bg-[#7B5338] border-[#7B5338] text-white" : "bg-white border-[#CDC0B0] text-[#9A8C7D]"} ${i === current ? "ring-4 ring-[#7B5338]/20" : ""}`}>
              {done ? <Check size={14} /> : <span className="text-xs">{i + 1}</span>}
            </span>
            <div className="pt-1">
              <p className={`text-base ${done ? "text-[#3A322B] font-medium" : "text-[#9A8C7D]"}`}>{s.label}</p>
              {ev && done && <p className="text-xs text-[#9A8C7D] mt-1">{fmtDate(ev.at)}</p>}
            </div>
          </li>
        );
      })}
    </ol>
  );
};
